/**
 * Зависимости модуля results
 * Получение функций из других модулей поиска
 */

// ⛓️ CURSOR_ANCHOR:search:results-dependencies

var getCurrentLang = function() {
  return window.SEARCH_LANGUAGE ? window.SEARCH_LANGUAGE.getCurrentLang() : 'en';
};

var getNothingFoundText = function() {
  return window.SEARCH_STATE ? window.SEARCH_STATE.getNothingFoundText() : 'Nothing found';
};

var escapeHtml = function(text) {
  return window.SEARCH_UTILS ? window.SEARCH_UTILS.escapeHtml(text) : text;
};

var stripHtmlTags = function(text) {
  return window.SEARCH_UTILS ? window.SEARCH_UTILS.stripHtmlTags(text) : text;
};

var initAccordion = function() {
  if (window.SEARCH_UI) {
    window.SEARCH_UI.initAccordion();
  }
};

var initDictNameHandlers = function() {
  if (window.SEARCH_UI) {
    window.SEARCH_UI.initDictNameHandlers();
  }
};

// Экспорт для использования в других модулях results/
window.SEARCH_RESULTS_DEPS = {
  getCurrentLang: getCurrentLang,
  getNothingFoundText: getNothingFoundText,
  escapeHtml: escapeHtml,
  stripHtmlTags: stripHtmlTags,
  initAccordion: initAccordion,
  initDictNameHandlers: initDictNameHandlers
};

